import { useCallback, useState } from "react";
import { openNativeLivoraCallShell } from "../plugins/NativeLivoraCall";
import "./NativeCallUiTestButton.css";

/**
 * Temporary dev-only button: opens the Phase 3B native call UI shell
 * (LivoraNativeCallActivity) via NativeLivoraCall.openShell(). No Zego
 * engine, no camera, no production call routing.
 */
export default function NativeCallUiTestButton() {
  const [busy, setBusy] = useState(false);

  const handleOpenShell = useCallback(async () => {
    if (busy) {
      return;
    }

    setBusy(true);
    try {
      const result = await openNativeLivoraCallShell();
      console.log("[nativeCallUiTest] result", result);
    } catch (error) {
      console.log("[nativeCallUiTest] error", String(error?.message || error));
    } finally {
      setBusy(false);
    }
  }, [busy]);

  return (
    <button
      type="button"
      className="native-call-ui-test-btn"
      onClick={handleOpenShell}
      disabled={busy}
      aria-label="Open Native Call UI"
    >
      Open Native Call UI
    </button>
  );
}
